define('model/traffic/trafficModelId',["../selector"], function (selector) {
    "use strict";
    return function (json) {
        return selector(json, "viewpResp.trafficState.@trafficModelId") || -1;
    };
});

